import styled from 'styled-components';

// CONSTANTS
import colors, { SANTAS_GRAY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

const { appCard } = colors;

export const Container = styled.div`
  &.carousel-apps,
  .carousel-apps {
    &__title {
      margin-right: 80px;
      margin-bottom: -30px;
      z-index: 2;
    }

    .swiper-container {
      width: calc(100% + 20px);
      padding: 0 25px 0 0;

      ${breakpoints.up('lg')} {
        width: calc(100% - 40px);
        padding: 0 30px 0 0;
        margin: 0 0 0 35px;
      }
    }
  }
`;

export const CarouselWrapper = styled.div`
  .card-wrapper {
    .app-card__logo {
      img {
        width: auto;
      }
    }
    .app-card-content__visit-site {
      z-index: 2;
    }
    &--see-all {
      .dummy-card {
        position: relative;

        color: ${p => p.theme.palette.text.primary};
        background-color: ${appCard.bg};
        border-radius: 8px;
        min-height: 393px;

        &__content {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          i {
            font-size: 36px;
            color: ${SANTAS_GRAY};
            margin-bottom: 20px;
          }

          span {
            color: ${p => p.theme.palette.text.primary};
          }
        }
      }
    }
  }

  .stage-carousel {
    .swiper-container {
      padding-top: 25px;
    }

    ${breakpoints.down('xs')} {
      .swiper-slide {
        width: 255px;
      }

      .swiper-container {
        padding-top: 16px;
      }
    }

    ${breakpoints.up('lg')} {
      .swiper-container {
        padding-top: 50px !important;
        margin-top: -25px;
      }

      .swiper-button-prev,
      .swiper-button-next {
        transform: translateY(0) !important;
      }
    }
  }
`;

export default Container;
